export const CUSTOMERS_URL = '/api/cmdb/customers/'
export const SOLUTIONS_URL = '/api/cmdb/solutions/'
export const DEVICES_URL = '/api/cmdb/devices/'
export const RUNBOOKS_URL = '/api/runbooks/'
export const ACTION_LOGS_URL = '/api/runbooks/action-logs/'
export const TEAMS_URL = '/api/accounts/teams/'
export const CONTACTS_URL = '/api/accounts/profiles/'
export const SUPPLIERS_URL = '/api/accounts/suppliers/'
export const OWNERS_URL = '/api/cmdb/owner/'
export const CMDB_CONTACTS_URL = '/api/cmdb/cmdb-contacts/users/'
export const CMDB_TEAMS_URL = '/api/cmdb/cmdb-contacts/teams/'
export const CMDB_SOLUTIONS_URL = '/api/cmdb/cmdb-solutions/'
export const CMDB_DEVICES_URL = '/api/cmdb/cmdb-devices/'
export const CMDB_DEVICES_ADVANCED_URL = '/api/cmdb/cmdb-devices-advanced/'
export const CMDB_CLASS_URL = '/api/cmdb/cmdb-device-classes/'
export const DOCUMENTATION_URL = '/api/documentation/entries/'
export const CUSTOMER_ZONES_URL = '/api/documentation/customer_zones/'
export const SD_URL =
    'https://sd.cegeka.com/CAisd/pdmweb.exe?OP=SEARCH+FACTORY=nr+SKIPLIST=1+QBE.IN.name='
export const MON_URL = 'https://mon.cegeka.be'
export const APP_CONTEXT_URL = '/api/app_context/'
